import { useDispatch } from 'react-redux';
import { configureStore, type EnhancedStore, type Reducer } from '@reduxjs/toolkit';
import createReducer from './rootReducer';

type EnhancedStoreExtended = EnhancedStore & { asyncReducers: any };

const store = configureStore({
	reducer: createReducer({}),
	middleware: getDefaultMiddleware => getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
	devTools: import.meta.env.DEV
}) as EnhancedStoreExtended;

store.asyncReducers = {};

export const injectReducer = (key: string, reducer: Reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(createReducer(store.asyncReducers));
	return store;
};

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
